import type { SelectOption } from 'naive-ui'
import type { CommentType } from '~/prisma/enums'
import { restrictedToSpecificUserSupportedTypes } from '~/server/schemas'

export default (commentType: Ref<CommentType | undefined>, entityId: Ref<string | undefined>) => {
  const { comment: commentQuery } = useQuery()
  const isSupportRestrictedToSpecificUser = computed(() => !!commentType.value && restrictedToSpecificUserSupportedTypes.includes(commentType.value))
  const i18n = useI18n()

  const { data: users } = commentQuery.getVisibleToOptions(
    isSupportRestrictedToSpecificUser,
    commentType,
    entityId,
  )

  const userOptions = computed((): SelectOption[] => {
    if (!users.value) {
      return []
    }

    return users.value.map(user => ({
      label: user.name ?? i18n.t('user.name.unknown'),
      value: user.id,
    }))
  })

  return { isSupportRestrictedToSpecificUser, userOptions }
}
